import { JointCanvasTemplateConfiguration } from '@/modules/ConfiguratorJoints/types/canvasTemplate';

// SVG assets bundled via webpack/file-loader as URL strings.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const leftExternalUrl: string = require('@/modules/ConfiguratorJoints/assets/corner-joint-left-external.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const rightExternalUrl: string = require('@/modules/ConfiguratorJoints/assets/corner-joint-right-external.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const leftInternalUrl: string = require('@/modules/ConfiguratorJoints/assets/corner-joint-left-internal.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const rightInternalUrl: string = require('@/modules/ConfiguratorJoints/assets/corner-joint-right-internal.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const guideBottomUrl: string = require('@/modules/ConfiguratorJoints/assets/alu-guide-bottom.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const guideTopUrl: string = require('@/modules/ConfiguratorJoints/assets/alu-guide-top.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const wireGuideUrl: string = require('@/modules/ConfiguratorJoints/assets/wire-guide.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const inoxGuideUrl: string = require('@/modules/ConfiguratorJoints/assets/inox-guide.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const slatConnector: string = require('@/modules/ConfiguratorJoints/assets/slat-connector.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const cornerJointInner: string = require('@/modules/ConfiguratorJoints/assets/corner-joint-inner.svg');

const sharedStageSize = {
    width: 600,
    height: 380,
    pivotX: 300,
    pivotY: 190,
};

// ── Pivot points ───────────────────────────────────────────────────────────
// Change these to move the rotation corner for each shape.
const externalPivotX = 300;
const externalPivotY = 190;
const internalPivotX = 300;
const internalPivotY = 190;

// Change these to move the angle-indicating arc + label independently of the pivot.
const arcAnchorPoints = {
    externalAnchorX: 243,
    externalAnchorY: 171,
    internalAnchorX: 224,
    internalAnchorY: 155,
};

const arcAnchorPointsTypeOne = {
    externalAnchorX: 243,
    externalAnchorY: 168,
    internalAnchorX: 224,
    internalAnchorY: 157,
};

export const baseExternalCanvasTemplate: JointCanvasTemplateConfiguration = {
    scale: 4,
    stageConfig: {
        ...sharedStageSize,
        x: 50,
        y: -50,
    },
    images: {
        left: { url: leftExternalUrl, widthMm: 42.753, heightMm: 18.653 },
        right: { url: rightExternalUrl, widthMm: 18.845718, heightMm: 46.952682 },
        inner: { url: cornerJointInner, widthMm: 32.161701, heightMm: 10.48212 },
    },
    rotatingHalf: 'right',
    pivot: { x: externalPivotX, y: externalPivotY },
    imageLeft: { x: externalPivotX - 57.39, y: externalPivotY - 3.1 },
    imageRight: { x: externalPivotX - 71, y: externalPivotY - 35 },
    slatConnectorUrl: slatConnector,
    // Inner overlay transform, ARM-LOCAL (relative to each arm's anchor).
    // 0,0 overlays it directly on the arm; tune x/y/rotate to reposition.
    leftInner: { x: -56, y: -24, rotate: 0 },
    rightInner: { x: 44, y: 144, rotate: -90 },
    pivotGlobalConfiguration: {
        pivotX: externalPivotX,
        pivotY: externalPivotY,
        leftCornerX: externalPivotX - 120,
        rightCornerX: externalPivotX - 71,
        leftCornerY: externalPivotY - 37,
        rightCornerY: externalPivotY - 35,
        arcAnchorX: arcAnchorPoints.externalAnchorX,
        arcAnchorY: arcAnchorPoints.externalAnchorY,
        arcAnchorXTypeOne: arcAnchorPointsTypeOne.externalAnchorX,
        arcAnchorYTypeOne: arcAnchorPointsTypeOne.externalAnchorY,
        rightArmLocalOriginX: 13.7,
        rightArmLocalOriginY: 17.1,
        regularGuideOneLeftArmX: -65,
        regularGuideOneLeftArmY: -36,
        regularGuideOneLeftArmRotation: 270,
        regularGuideTwoLeftArmX: -185,
        regularGuideTwoLeftArmY: -61,
        regularGuideTwoLeftArmRotation: 90,
        regularGuideOneRightArmX: 33,
        regularGuideOneRightArmY: 145,
        regularGuideOneRightArmRotation: 0,
        regularGuideTwoRightArmX: 58,
        regularGuideTwoRightArmY: 25,
        regularGuideTwoRightArmRotation: 180,
        wireGuideOneLeftArmX: -80,
        wireGuideOneLeftArmY: -53,
        wireGuideOneLeftArmRotation: 270,
        wireGuideTwoLeftArmX: -172,
        wireGuideTwoLeftArmY: -61,
        wireGuideTwoLeftArmRotation: 90,
        wireGuideOneRightArmX: 50,
        wireGuideOneRightArmY: 132,
        wireGuideOneRightArmRotation: 0,
        wireGuideTwoRightArmX: 58,
        wireGuideTwoRightArmY: 38,
        wireGuideTwoRightArmRotation: 180,
        inoxGuideOneLeftArmX: -80,
        inoxGuideOneLeftArmY: -53,
        inoxGuideOneLeftArmRotation: 270,
        inoxGuideTwoLeftArmX: -173,
        inoxGuideTwoLeftArmY: -60,
        inoxGuideTwoLeftArmRotation: 90,
        inoxGuideOneRightArmX: 50,
        inoxGuideOneRightArmY: 133,
        inoxGuideOneRightArmRotation: 0,
        inoxGuideTwoRightArmX: 57,
        inoxGuideTwoRightArmY: 38,
        inoxGuideTwoRightArmRotation: 180,
        slatConnectorX: 40,
        slatConnectorY: -40,
        slatConnectorWidthMm: 20,
        slatConnectorHeightMm: 20,
        slatConnectorRotation: 90,
        slatConnectorScale: 0.33,
    },
    arcAnchor: { x: arcAnchorPoints.externalAnchorX, y: arcAnchorPoints.externalAnchorY },
    // Guides — 2 per arm (top rail + bottom rail).
    //   left arm  → horizontal (static)  → selfRotation:90 makes the cross-section vertical
    //   right arm → vertical  (rotating) → no selfRotation, moves with the arm
    guides: {
        leftBottom: {
            url: guideBottomUrl,
            widthMm: 6.2226849,
            heightMm: 2.0390701,
            x: 85,
            y: 143,
            selfRotation: 90,
        },
        leftTop: {
            url: guideTopUrl,
            widthMm: 6.2318535,
            heightMm: 2.0480919,
            x: 93,
            y: 143,
            selfRotation: 90,
        },
        rightBottom: {
            url: guideBottomUrl,
            widthMm: 6.2226849,
            heightMm: 2.0390701,
            x: 225,
            y: 285,
        },
        rightTop: {
            url: guideTopUrl,
            widthMm: 6.2318535,
            heightMm: 2.0480919,
            x: 250,
            y: 285,
        },
        wireGuide: {
            url: wireGuideUrl,
            widthMm: 41,
            heightMm: 41,
            scale: 0.05,
        },
        inoxGuide: {
            url: inoxGuideUrl,
            widthMm: 35,
            heightMm: 35,
            scale: 0.05,
        },
    },
};

export const baseInternalCanvasTemplate: JointCanvasTemplateConfiguration = {
    scale: 4,
    stageConfig: {
        ...sharedStageSize,
        x: -50,
        y: 50,
    },
    images: {
        left: { url: leftInternalUrl, widthMm: 19.981121, heightMm: 43.362976 },
        right: { url: rightInternalUrl, widthMm: 53.354897, heightMm: 20.181267 },
        inner: { url: cornerJointInner, widthMm: 32.161701, heightMm: 10.48212 },
    },
    rotatingHalf: 'left',
    pivot: { x: internalPivotX, y: internalPivotY },
    imageLeft: { x: internalPivotX - 75, y: internalPivotY - 37 },
    imageRight: { x: internalPivotX - 117, y: internalPivotY - 37 },
    slatConnectorUrl: slatConnector,
    // Inner overlay transform, ARM-LOCAL (relative to each arm's anchor).
    // 0,0 overlays it directly on the arm; tune x/y/rotate to reposition.
    // leftInner: { x: -42, y: -1, rotate: 90 },
    // rightInner: { x: 170, y: 45, rotate: 180 },
    leftInner: { x: -54, y: 1, rotate: 90 },
    rightInner: { x: 168, y: 33, rotate: 180 },
    pivotGlobalConfiguration: {
        pivotX: internalPivotX,
        pivotY: internalPivotY,
        leftCornerX: internalPivotX - 75,
        rightCornerX: internalPivotX - 117,
        leftCornerY: internalPivotY - 37,
        rightCornerY: internalPivotY - 37,
        arcAnchorX: arcAnchorPoints.internalAnchorX,
        arcAnchorY: arcAnchorPoints.internalAnchorY,
        arcAnchorXTypeOne: arcAnchorPointsTypeOne.internalAnchorX,
        arcAnchorYTypeOne: arcAnchorPointsTypeOne.internalAnchorY,
        rightArmLocalOriginX: 0,
        rightArmLocalOriginY: 0,
        regularGuideOneLeftArmX: -42,
        regularGuideOneLeftArmY: -8,
        regularGuideOneLeftArmRotation: 0,
        regularGuideTwoLeftArmX: -17,
        regularGuideTwoLeftArmY: -128,
        regularGuideTwoLeftArmRotation: 180,
        regularGuideOneRightArmX: 168,
        regularGuideOneRightArmY: 43,
        regularGuideOneRightArmRotation: 270,
        regularGuideTwoRightArmX: 50,
        regularGuideTwoRightArmY: 18,
        regularGuideTwoRightArmRotation: 90,
        wireGuideOneLeftArmX: -25,
        wireGuideOneLeftArmY: -22,
        wireGuideOneLeftArmRotation: 0,
        wireGuideTwoLeftArmX: -17,
        wireGuideTwoLeftArmY: -117,
        wireGuideTwoLeftArmRotation: 180,
        wireGuideOneRightArmX: 156,
        wireGuideOneRightArmY: 26,
        wireGuideOneRightArmRotation: 270,
        wireGuideTwoRightArmX: 62,
        wireGuideTwoRightArmY: 20,
        wireGuideTwoRightArmRotation: 90,
        inoxGuideOneLeftArmX: -25,
        inoxGuideOneLeftArmY: -22,
        inoxGuideOneLeftArmRotation: 0,
        inoxGuideTwoLeftArmX: -17,
        inoxGuideTwoLeftArmY: -117,
        inoxGuideTwoLeftArmRotation: 180,
        inoxGuideOneRightArmX: 156,
        inoxGuideOneRightArmY: 26,
        inoxGuideOneRightArmRotation: 270,
        inoxGuideTwoRightArmX: 62,
        inoxGuideTwoRightArmY: 20,
        inoxGuideTwoRightArmRotation: 90,
        slatConnectorX: -35,
        slatConnectorY: 35,
        slatConnectorWidthMm: 20,
        slatConnectorHeightMm: 20,
        slatConnectorRotation: 270,
        slatConnectorScale: 0.33,
    },
    arcAnchor: { x: arcAnchorPoints.internalAnchorX, y: arcAnchorPoints.internalAnchorY },
    // Guides — 2 per arm (top rail + bottom rail).
    //   left arm  → vertical  (rotating) → no selfRotation, moves with the arm
    //   right arm → horizontal (static)  → selfRotation:90 makes the cross-section vertical
    guides: {
        leftBottom: {
            url: guideBottomUrl,
            widthMm: 6.2226849,
            heightMm: 2.0390701,
            x: 225,
            y: 275,
        },
        leftTop: {
            url: guideTopUrl,
            widthMm: 6.2318535,
            heightMm: 2.0480919,
            x: 250,
            y: 275,
        },
        rightBottom: {
            url: guideBottomUrl,
            widthMm: 6.2226849,
            heightMm: 2.0390701,
            x: 347,
            y: 159,
            selfRotation: 90,
        },
        rightTop: {
            url: guideTopUrl,
            widthMm: 6.2318535,
            heightMm: 2.0480919,
            x: 355,
            y: 159,
            selfRotation: 90,
        },
        wireGuide: {
            url: wireGuideUrl,
            widthMm: 41,
            heightMm: 41,
            scale: 0.05,
        },
        inoxGuide: {
            url: inoxGuideUrl,
            widthMm: 35,
            heightMm: 35,
            scale: 0.05,
        },
    },
};
